export default "__VITE_ASSET__DMvFjWIq__"